export default __webpack_public_path__ + "static/media/transport.02e96354.jpg";